document.addEventListener('DOMContentLoaded', () => {
    type MemberDetails = {
        name: string,
        position: string,
        phone: string,
        mail: string,
        roof: string,
        color: string,
        material: string
    }

    const toggleElem = document.querySelectorAll('.js-expand-team-member');
    const detailsElem = document.querySelector('.memberDetails__outer') as HTMLElement;
    const triangleElem = document.querySelector('.memberDetails__triangle') as HTMLElement;

    let currentOpenMember: HTMLElement | null = null;
    let detailsAreVisible = false;

    toggleElem.forEach((elem) => {
        elem.addEventListener('click', (e) => {
            e.preventDefault();
            const parent = elem.closest('.team__member') as HTMLElement;

            const memberData: MemberDetails = {
                name: parent.getAttribute('data-name') || '',
                position: parent.getAttribute('data-position') || '',
                phone: parent.getAttribute('data-phone') || '',
                mail: parent.getAttribute('data-mail') || '',
                roof: parent.getAttribute('data-roof') || '',
                color: parent.getAttribute('data-color') || '',
                material: parent.getAttribute('data-material') || ''
            };

            if (currentOpenMember === parent && detailsAreVisible) {
                shrinkDetails();
            } else {
                updateContent(memberData);

                if (currentOpenMember) {
                    switchDetails(currentOpenMember, parent);
                } else {
                    expandDetails(parent);
                }
            }
        })
    })

    const updateContent = (d: MemberDetails) => {
        const positionElement = document.querySelector('.js-input-position');
        const materialElement = document.querySelector('.js-input-material');
        const phoneElement = document.querySelector('.js-input-phone');
        const colorElement = document.querySelector('.js-input-color');
        const mailElement = document.querySelector('.js-input-mail');
        const nameElement = document.querySelector('.js-input-name');
        const roofElement = document.querySelector('.js-input-roof');

        if(nameElement) nameElement.innerHTML = d.name;
        if(positionElement) positionElement.innerHTML = d.position;

        if(phoneElement) {
            phoneElement.innerHTML = d.phone;
            phoneElement.setAttribute('href', `tel:${d.phone.trim()}`);
        }

        if(mailElement) {
            mailElement.innerHTML = d.mail;
            mailElement.setAttribute('href', `mailto:${d.mail}`);
        }

        if(roofElement) roofElement.setAttribute('src', d.roof);
        if(materialElement) materialElement.setAttribute('src', d.material);
        if(colorElement) colorElement.setAttribute('src', d.color);
    }

    // HILFSFUNKTION: Berechnet exakt die Unterkante des Inhalts (ohne Spacer-Höhe!)
    const getMemberContentBottom = (member: HTMLElement) => {
        const spacer = member.querySelector('.team__memberSpacer') as HTMLElement;
        // spacer.offsetTop gibt die Position des Spacers relativ zum member-div.
        // Das entspricht genau der Höhe von Bild + Text.
        return member.offsetTop + spacer.offsetTop;
    }

    const getRequiredHeight = () => {
        const contentInner = document.querySelector('.memberDetails') as HTMLElement;
        // Puffer + Padding (1rem = 16px)
        return contentInner.scrollHeight + 5;
    }

    const switchDetails = (oldMember: HTMLElement, newMember: HTMLElement) => {
        const oldSpacer = oldMember.querySelector('.team__memberSpacer') as HTMLElement;
        const newSpacer = newMember.querySelector('.team__memberSpacer') as HTMLElement;
        const requiredHeight = getRequiredHeight();

        // Prüfen, ob wir in der gleichen Zeile sind (Toleranz für Subpixel)
        const isSameRow = Math.abs(oldMember.offsetTop - newMember.offsetTop) < 10;

        if (isSameRow) {
            // GLEICHE ZEILE: "Teleportieren" ohne Animation
            if(oldSpacer) {
                oldSpacer.style.transition = 'none';
                oldSpacer.style.height = '0px';
            }
            if(newSpacer) {
                newSpacer.style.transition = 'none';
                newSpacer.style.height = `${requiredHeight}px`;
            }

            // Position neu setzen
            const topPosition = getMemberContentBottom(newMember);
            detailsElem.style.top = `${topPosition}px`;
            detailsElem.style.maxHeight = `${requiredHeight}px`;

            updateTriangle(newMember);
            currentOpenMember = newMember;

            // Transition wiederherstellen
            requestAnimationFrame(() => {
                if(oldSpacer) oldSpacer.style.transition = '';
                if(newSpacer) newSpacer.style.transition = '';
            });

        } else {
            // ANDERE ZEILE:
            const oldSpacerHeight = oldSpacer ? oldSpacer.offsetHeight : 0;

            // Ist das neue Element visuell UNTER dem alten?
            // Wenn ja, beinhaltet sein offsetTop die Höhe des alten Spacers.
            const isBelow = newMember.offsetTop > oldMember.offsetTop;

            // Wir holen uns die "reine" Unterkante des Inhalts
            let targetTop = getMemberContentBottom(newMember);

            if (isBelow) {
                // Da das Grid noch aufgedrückt ist, ziehen wir die alte Spacer-Höhe ab,
                // um die Position zu erhalten, die es HABEN WIRD, wenn oben zugeht.
                targetTop = targetTop - oldSpacerHeight;
            }

            // 1. Details-Box positionieren
            detailsElem.style.top = `${targetTop}px`;
            detailsElem.style.maxHeight = `${requiredHeight}px`;

            // 2. Animation starten
            if (oldSpacer) oldSpacer.style.height = '0px';
            if (newSpacer) newSpacer.style.height = `${requiredHeight}px`;

            updateTriangle(newMember);
            currentOpenMember = newMember;
        }
    }

    const expandDetails = (member: HTMLElement) => {
        const spacer = member.querySelector('.team__memberSpacer') as HTMLElement;
        const totalHeight = getRequiredHeight();

        // Padding setzen (wichtig: vor Berechnungen, falls relevant für Optik)
        detailsElem.style.paddingTop = '1rem';

        // Hier nutzen wir die neue, sichere Berechnung
        const topPosition = getMemberContentBottom(member);

        detailsElem.style.top = `${topPosition}px`;
        detailsElem.style.maxHeight = `${totalHeight}px`;

        if(spacer) {
            spacer.style.height = `${totalHeight}px`;
        }

        updateTriangle(member);

        currentOpenMember = member;
        detailsAreVisible = true;
    }

    const shrinkDetails = () => {
        detailsElem.style.maxHeight = '0px';
        detailsElem.style.paddingTop = '0px';

        if (currentOpenMember) {
            const spacer = currentOpenMember.querySelector('.team__memberSpacer') as HTMLElement;
            if (spacer) spacer.style.height = '0px';
        }

        currentOpenMember = null;
        detailsAreVisible = false;
    }

    const updateTriangle = (member: HTMLElement) => {
        if(triangleElem) {
            // Mitte relativ zum Bild
            const centerOfMember = member.offsetLeft + (member.offsetWidth / 2);
            triangleElem.style.left = `${centerOfMember + 25}px`;
            triangleElem.style.transform = `translateX(-50%) rotate(45deg)`;
        }
    }

    window.addEventListener('resize', () => {
        if(detailsAreVisible) shrinkDetails();
    });
})